var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupsunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.727 45.645C16.727 61.299 29.417 73.991 45.071 73.991C60.725 73.991 73.417 61.3 73.417 45.645C73.417 29.993 60.726 17.303 45.071 17.303C29.417 17.303 16.727 29.992 16.727 45.645Z",
    fill: "url(#paint0_radial_3_22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.391 42.73C42.172 36.871 39.352 27.957 43.094 22.81C46.838 17.664 55.726 18.244 62.948 24.095C70.165 29.95 72.981 38.87 69.241 44.013C65.494 49.162 56.607 48.582 49.391 42.73Z",
    fill: "url(#paint1_radial_3_22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.02 51.91C20.977 48.775 25.836 50.074 30.881 54.812C35.926 59.55 39.236 65.929 38.285 69.068C37.331 72.201 32.47 70.904 27.424 66.166C22.381 61.426 19.066 55.041 20.02 51.91Z",
    fill: "url(#paint2_radial_3_22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.509 8.922C48.509 10.822 46.971 12.36 45.071 12.36C43.172 12.36 41.633 10.822 41.633 8.922V4.04499C41.633 2.14499 43.171 0.606995 45.071 0.606995C46.97 0.606995 48.509 2.14499 48.509 4.04499V8.922Z",
    fill: "url(#paint3_radial_3_22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.533 17.248C22.877 18.592 22.877 20.768 21.534 22.11C20.19 23.453 18.015 23.453 16.672 22.109L13.224 18.661C11.88 17.317 11.88 15.143 13.223 13.799C14.566 12.456 16.742 12.456 18.085 13.8L21.533 17.248Z",
    fill: "url(#paint4_radial_3_22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34701 42.211C10.247 42.211 11.785 43.749 11.785 45.649C11.785 47.548 10.248 49.087 8.34701 49.087H3.47001C1.57001 49.087 0.0320059 47.549 0.0310059 45.649C0.0310059 43.749 1.57001 42.211 3.47001 42.211H8.34701Z",
    fill: "url(#paint5_radial_3_22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.673 69.186C18.017 67.842 20.193 67.842 21.534 69.186C22.878 70.53 22.878 72.704 21.534 74.047L18.086 77.496C16.742 78.84 14.567 78.84 13.224 77.498C11.88 76.154 11.881 73.978 13.225 72.635L16.673 69.186Z",
    fill: "url(#paint6_radial_3_22)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.634 82.373C41.634 80.473 43.173 78.934 45.072 78.935C46.972 78.935 48.51 80.472 48.51 82.373L48.512 87.25C48.512 89.15 46.973 90.688 45.074 90.689C43.174 90.689 41.636 89.15 41.636 87.25L41.634 82.373Z",
    fill: "url(#paint7_radial_3_22)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.61 74.047C67.266 72.703 67.265 70.527 68.61 69.186C69.954 67.842 72.128 67.842 73.471 69.186L76.92 72.633C78.264 73.977 78.263 76.153 76.922 77.496C75.577 78.84 73.402 78.838 72.059 77.494L68.61 74.047Z",
    fill: "url(#paint8_radial_3_22)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.798 49.084C79.898 49.084 78.359 47.547 78.36 45.646C78.36 43.746 79.897 42.208 81.798 42.208H86.675C88.575 42.208 90.113 43.747 90.115 45.645C90.114 47.546 88.575 49.083 86.675 49.083L81.798 49.084Z",
    fill: "url(#paint9_radial_3_22)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.471 22.108C72.127 23.452 69.952 23.453 68.61 22.108C67.266 20.764 67.266 18.59 68.61 17.247L72.058 13.799C73.402 12.455 75.578 12.456 76.921 13.797C78.264 15.142 78.263 17.316 76.919 18.66L73.471 22.108Z",
    fill: "url(#paint10_radial_3_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5538 27.8754) rotate(180) scale(53.8071 53.8071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.1671 33.4116) rotate(126.034) scale(11.5221 16.8086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1524 60.4893) rotate(-136.79) scale(12.5291 5.3216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6973 2.34319) scale(9.3624 9.3624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8935 14.5844) rotate(-45) scale(9.36261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.76711 45.0224) rotate(-90) scale(9.3623 9.3623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0083 75.8264) rotate(-135) scale(9.36271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4461 88.9526) rotate(180) scale(9.3626 9.3626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.2515 76.7112) rotate(135) scale(9.36281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.3775 46.2725) rotate(90) scale(9.3623 9.3623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.1354 15.4677) rotate(45) scale(9.36261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsunny);
export default __webpack_public_path__ + "static/media/Groupsunny.5bf3a7f1b1d642d533a183a2a63a66cb.svg";
export { ForwardRef as ReactComponent };